exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete[data-v-3de0cf89]:hover, .edit[data-v-3de0cf89]:hover {\n    cursor: pointer;\n}\n.form-group .error[data-v-3de0cf89] {\n    font-size: 0.8rem;\n    color: #f44336;\n}\n.form-group[data-v-3de0cf89] {\n    position: relative;\n}\n.form-group button[data-v-3de0cf89] {\n    position: absolute;\n    right: 0;\n    top: -4px;\n    min-width: 30px;\n    width: 30px;\n    height: 30px;\n}\n.form-group .material-icons[data-v-3de0cf89] {\n    line-height: 30px;\n}\n.card[data-v-3de0cf89] {\n    margin-top: 10px;\n}\n", ""]);

// exports
